import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { type UseMutationRequestOptions, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

export type AffiliationAcquirer = 'pag_seguro'

export type CreateAffiliationConsentVariables = {
  paymentProfileId: string
  acquirer: AffiliationAcquirer
}

export type ConsentUrlResponse = {
  pagSeguro?: string
}

async function createAffiliationConsent({
  paymentProfileId,
  acquirer
}: CreateAffiliationConsentVariables): Promise<ConsentUrlResponse> {
  const { data } = await httpClientVendasCoreBff<ConsentUrlResponse>({
    url: `/v1/payment-profile/${paymentProfileId}/affiliations/consents`,
    method: 'POST',
    data: { acquirer }
  })
  return data
}

export function useCreateAffiliationConsent(
  options?: UseMutationRequestOptions<ConsentUrlResponse, unknown, true, CreateAffiliationConsentVariables>
) {
  return useMutationRequest<ConsentUrlResponse, unknown, true, CreateAffiliationConsentVariables>(
    ['useCreateAffiliationConsent'],
    createAffiliationConsent,
    options
  )
}
